import { TffCenterInfoFragment } from "@generated-types"
import dayjs from "dayjs"

export function formatTffCenterStatus(info: TffCenterInfoFragment) {
  let datesText = ""
  let saleStatusLabel = ""
  let onSale = false
  let hasDates = false
  let venueName = ""

  let priority = 0

  if (info.showVenueName && info.primaryVenue) {
    venueName = info.primaryVenue
  }

  if (info.status === "on-sale") {
    saleStatusLabel = "On Sale Now"
    onSale = true
    priority += 4
  } else if (info.status === "not-on-sale") {
  } else if (info.status === "on-sale-soon") {
    saleStatusLabel = "On Sale Soon"
    priority += 3
    if (info.onSaleDate) {
      saleStatusLabel = "On Sale " + dayjs(info.onSaleDate).format("D MMMM")
    }
  }

  if (info.showFestivalDates) {
    const startDate = dayjs(info.festivalStartDate)
    const endDate = dayjs(info.festivalEndDate)
    priority += 2
    hasDates = true
    if (startDate.isSame(endDate, "month")) {
      datesText = startDate.format("D") + "—" + endDate.format("D MMMM YYYY")
    } else {
      datesText = startDate.format("D MMM") + "—" + endDate.format("D MMM YYYY")
    }
  } else if (info.monthAndYear) {
    datesText = "Returning " + info.monthAndYear
    priority += 1
  }

  return {
    datesText,
    saleStatusLabel,
    onSale,
    hasDates,
    venueName,
    priority,
  }
}

const stateNames: Record<string, string> = {
  ACT: "Australian Capital Territory",
  NSW: "New South Wales",
  NT: "Northern Territory",
  QLD: "Queensland",
  SA: "South Australia",
  TAS: "Tasmania",
  VIC: "Victoria",
  WA: "Western Australia",
}
export function getAUStateName(state: string) {
  return stateNames[state.toUpperCase()] || state
}

export type TFFCenterStatus = ReturnType<typeof formatTffCenterStatus>
